/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['skins.viewer.pinterestfollow.PinterestFollowSkin'] = {
  "react": [
    [
      "a",
      "followButton",
      [],
      {
        "target": "_blank"
      },
      [
        "div",
        "followButtonTag",
        [],
        {}
      ],
      [
        "div",
        null,
        [
          "_icon"
        ],
        {}
      ]
    ]
  ],
  "params": {
    "tdr": "URL"
  },
  "paramsDefaults": {
    "tdr": "BASE_THEME_DIRECTORY"
  },
  "css": {
    "%": "display:table;",
    "%:hover %followButtonTag": "border:1px solid #aaaaaa;",
    "%:active %followButtonTag": "background:rgba(0, 0, 0, 0) url([tdr]pinterest_follow_down.jpg) 0 0 repeat-x;",
    "%followButton": "display:inline-block;",
    "%followButtonTag": "color:#444;font:bold normal normal 11px/20px \"Helvetica Neue\", helvetica, arial, san-serif !important;height:16px;margin:0;padding:0 4px 2px 22px;border-radius:3px;position:relative;text-decoration:none;vertical-align:baseline;background:rgba(0, 0, 0, 0) url([tdr]pinterest_follow.jpg) 0 0 repeat-x;border:1px solid #c9c9c5;white-space:nowrap;",
    "%_icon": "position:absolute;top:3px;left:5px;height:14px;width:14px;background-size:14px 14px;background-image:url([tdr]log1.png);"
  }
}

    return skins;
});
